import { agencyResource } from './../organizationalManage/request';
import { reminderList, reminderStatus, delReminder } from './request';
import reminderModel from './reminderModel.vue';
export default {
  components: {
    reminderModel
  },
  data() {
    return {
      reminderShow: false,
      form: {
        name: '',
        agencyId: undefined
      },
      agencyList: [],
      columns: [{
        slots: {
          title: 'id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '模版名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '所属机构'
        },
        dataIndex: 'agencyName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '创建人'
        },
        dataIndex: 'userName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        width: 150,
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: []
    };
  },
  created() {
    agencyResource({}).then(res => {
      console.log(res, 99993);
      this.agencyList = res;
    });
    this.getDataFun();
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      reminderList(obj).then(res => {
        console.log(res);
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleAdd() {
      this.reminderShow = true;
      this.$nextTick(() => {
        this.$refs.reminderFrom.init({});
      });
    },
    handleEdit(data) {
      this.reminderShow = true;
      this.$nextTick(() => {
        this.$refs.reminderFrom.init(data);
      });
    },
    checkedFun(val) {
      console.log(val);
      if (!this.isAuth('home.insuranceReminderStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      reminderStatus({
        reminderId: val.reminderId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    getReminderTable() {
      this.reminderShow = false;
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该投保提醒') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delReminder({
          reminderId: val.reminderId
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getDataFun();
        });
      });
    }
  }
};